import { faRankingStar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { WPLeaderboard } from '~/components/organisms/WPLeaderboard';

export type IAppWPLeaderboardPageProps = {
  appId: string;
};

export const AppWPLeaderboardPage: React.FC<IAppWPLeaderboardPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppWPLeaderboardPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('AppWPLeaderboardPage.title')}
        subtitle={t('AppWPLeaderboardPage.subtitle')}
        icon={<FontAwesomeIcon icon={faRankingStar} />}
      />

      <WPLeaderboard appId={appId} />
    </>
  );
};
